import { tv } from "tailwind-variants";

export const description = tv({
    base: [
        "tw:w-full tw:pb-px tw:overflow-y-hidden tw:truncate",
        "tw:before:content-['■'] tw:before:text-primary tw:before:mr-2"
    ]
});
